import React from "react";
import { Link, useNavigate } from "react-router-dom";
import InfoIcon from "../../../styles/img/svg/InfoIcon";
import HeartIcon from "../../../styles/img/svg/HeartIcon";
import EntryRightIcon from "../../../styles/img/svg/EntryRightIcon";
import PropTypes from "prop-types";
import { timeFormatUtcToLocal } from "../../../_helpers/support.services";
import UiTopSelectLatestSuccess from "../form/UiTopSelectLatestSuccess";
import TeamCodeRight from "../../../styles/img/svg/TeamCodeRight";
import TeamCodeCross from "../../../styles/img/svg/TeamCodeCross";
import UiTeamCodeSelect from "../form/UiTeamCodeSelect";
import Select, { components } from "react-select";
import DownArrow from "../../../styles/img/down-arrow.png";

export function UiSalesChainElementWr(props) {
    return (
        <>
            <div className="sb-sales-chain">
                <ul>{props.children}</ul>
            </div>
        </>
    );
}

export function UiSalesChainElement(props) {
    const navigate = useNavigate();

    return (
        <>
            <li
                className={
                    props.isActive
                        ? "sb-sales-active"
                        : "" || props.isEntryActive
                            ? "sb-sales-active-entry"
                            : ""
                }
            >
                <div className="sb-sales-chain__icon">
                    {props.isActive ? (
                        <HeartIcon />
                    ) : (
                        !props.isEntryActive && <InfoIcon />
                    )}
                    {props.isEntryActive && <EntryRightIcon />}
                </div>
                <div className="sb-sales-chain__content">
                    <div className="sb-sales-chain__left">
                        <label style={props.valueRequirment ? { color: '#FD7D56' } : {}}>
                            {props.salesStatus}</label>

                        <span style={props.valueRequirment ? { color: '#FD7D56' } : {}}>
                            {/* <span className="sb-sales-chain__id-text">
                                    ID
                                </span> */}

                            {props.salesId}
                        </span>
                    </div>
                    <div className="sb-sales-chain__right">
                        {/* {props.redeem && 
                           
                            <UiTopSelectLatestSuccess/>
                        } */}
                        {/* {props.clipBoard && (
                            <span
                                className="sb-sales-chain__copy"
                                onClick={props.copyCode}
                            >
                                Copy Code
                            </span>
                        )}*/}
                        {props.date && (
                            <div className="sb-sales-chain__date">
                                {timeFormatUtcToLocal(props.date)}
                            </div>
                        )}

                        {props.goButton && (
                            <div
                                onClick={() => {
                                    if (props.type == "CAMPAIGN") {
                                        navigate("/app/campaigns/" + props.id);
                                    }

                                    if (props.type == "QUIZ") {
                                        navigate("/app/learn/" + props.id);
                                    }

                                    if (props.type == "POINTS") {
                                        navigate("/app/shop/browse-products");
                                    }

                                    if (props.type == "SALE") {
                                        navigate("/app/campaigns/" + props.id);
                                    }
                                }}
                                className="sb-sales-chain__go-btn"
                            >
                                <span>Go</span>
                            </div>
                        )}
                    </div>
                </div>
            </li>
        </>
    );
}

export function UiSalesChainElementNoBgWr(props) {
    return (
        <>
            <div className="sb-sales-chain sb-sales-chain-no-bg">
                <ul>{props.children}</ul>
            </div>
        </>
    );
}

export function UiTeamGameCodeElement(props) {
    const navigate = useNavigate();

    const { onChange, options, placeholder, value, reset, used, idDisabled, usedOption } = props;
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <img src={DownArrow} />
            </components.DropdownIndicator>
        );
    };
    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },

    };

    return (
        <>
            <li
                className={
                    props.isActive ? "sb-code-item-active" : ""
                }
            >
                <div className="sb-sales-chain__icon">
                    {props.isActive ?
                        <TeamCodeRight />
                        : <TeamCodeCross />}

                </div>
                <div className="sb-sales-chain__content">
                    <div className="sb-sales-chain__left">
                        <label style={!props.isActive ? { color: '#b7b3b3' } : {}}>
                            {props.name}
                        </label>
                        <span style={!props.isActive ? { color: '#b7b3b3' } : {}}>
                            {props.code}
                        </span>
                    </div>
                    <div className="sb-sales-chain__center">
                        <div className={reset ? 'sb-select-reset-bg sb-top-area-element' :
                            used ? 'sb-selet-used-bg sb-top-area-element' :
                                'sb-top-area-element'}>
                            <Select
                                onChange={onChange}
                                className="basic-single"
                                classNamePrefix="select"
                                components={{ DropdownIndicator }}
                                styles={colorStyles}
                                placeholder={placeholder}
                                options={!idDisabled ? options : usedOption}                              
                                value={value}
                                isDisabled={idDisabled}
                                menuPortalTarget={document.body}
                                menuShouldScrollIntoView={true}
                                defaultValue={idDisabled ? usedOption[0] : options[0]}                             
                            />
                        </div>
                    </div>
                    <div className="sb-sales-chain__right">
                        <div className="sb-team-codes-btn">
                            {reset ? <span onClick={props.handleReset} className="sb-team-codes-btn__reset">Reset</span> :
                                used ? <span className="sb-team-codes-btn__used">Used</span> : <span onClick={props.handleSend} className="sb-team-codes-btn__send">Send</span>}
                        </div>
                    </div>
                </div>
            </li>
        </>
    );
}

UiSalesChainElement.propTypes = {
    isActive: PropTypes.bool,
    salesStatus: PropTypes.string,
    salesId: PropTypes.string,
    date: PropTypes.string,
};
